<template>
  <v-card class="ma-4" :style="chartSize" id="overdue-chart">
    <chart
      type="line-chart"
      :data="_chart.data"
      :labels="_chart.labels"
      secondaryTitle="1300"
      width="95%"
      elevation="0"
    >
      <div
        class="d-flex justify-space-between"
        style="width:100%;"
        id="overdue-chart-title"
      >
        <v-card-title class="pb-0 font-weight-bold">
          {{ _chart.title }}
        </v-card-title>
        <div>
          <v-card-text
            class="pb-0 tex-subtitle-2 font-weight-light"
            id="overdue-reported"
          >
            {{ _chart.secondaryTitle }}
          </v-card-text>
          <v-card-text class="text-h5 font-weight-bold py-0 ">
            <span class="red--text">
              {{ overdue }}
            </span>
            /
            <span>
              {{ reported }}
            </span>
          </v-card-text>
        </div>
      </div>
    </chart>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import Chart from '@/components/charts/Chart';
import { MobileView } from '@/mixins';

export default {
  components: {
    Chart,
  },
  mixins: [MobileView],
  computed: {
    ...mapGetters({
      _chart: 'reconciliation/getOverdueChart',
    }),
    overdue() {
      return this._chart.data[0].data.reduce((a, b) => a + b, 0);
    },
    reported() {
      return this._chart.data[1].data.reduce((a, b) => a + b, 0);
    },
    chartSize() {
      if (!this.showMobileView) {
        return 'width: 70%; overflow: hidden;';
      }
      return '';
    },
  },
};
</script>
